import { render, staticRenderFns } from "./edit_button.vue?vue&type=template&id=4916ec94&scoped=true&lang=pug"
import script from "./edit_button.vue?vue&type=script&lang=js"
export * from "./edit_button.vue?vue&type=script&lang=js"
import style0 from "./edit_button.vue?vue&type=style&index=0&id=4916ec94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4916ec94",
  null
  
)

export default component.exports